module.exports = __webpack_public_path__ + "media/images/homepage/img1-4fc10b8de69af1f92561deccf98924be.jpg";